import DatePicker from 'vue2-datepicker';
import appStrings from '@/app/utility/string.utility';
import commonHelper from '@/app/utility/common.helper.utility';
import uploadExcelDetails from '../../shared/uploadExcel/uploadExcelDetails';
export default {
  components: { DatePicker, appStrings, uploadExcelDetails },
  props: ['formName'],
  name: 'uploadedData',
  data() {
    return {
      loader: false,
      module: {
        text: null,
        value: null
      },
      user: {
        text: null,
        value: null
      },
      defaultValue: {
        value: null,
        text: null
      },
      fileName: null,
      uploadedFrom: null,
      uploadedTo: null,
      showValueSetModal: false,
      parent_value_set_id: null,
      users: [],
      uploadedData: [],
      uploadedFields: [
        {
          key: 'created_by',
          label: 'Created By',
          class: 'text-center'
        },
        {
          key: 'creation_date',
          label: 'Date Created',
          class: 'text-center'
        },
        {
          key: 'excel_name',
          label: 'Excel Name',
          class: 'text-center'
        },
        {
          key: 'attribute15',
          label: 'Status',
          class: 'text-center'
        },
        {
          key: 'attribute14',
          label: 'Update',
          class: 'text-center'
        },
        {
          key: 'upload',
          label: 'Upload',
          class: 'text-center'
        }
      ],
      pageOptions: commonHelper.getPageOption(),
      perPage: commonHelper.perPageRecord,
      currentPage: 1,
      totalRows: null,
      showExcelDetailsModal: false,
      excelRowDtl: null,
      sheetIndex: null,
      uploadExcelData: [],
      recordId: null,
      excelProcess: {
        value: null,
        text: null
      },
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      editMode: false,
      excelImportId: null
    };
  },
  watch: {
    currentPage: function() {
      this.getUploadedData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getUploadedData();
    }
  },
  methods: {
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.PROVISION_EMP) {
        this.user = {
          value: item.user_id,
          text: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.MODULE_LIST) {
        this.module = {
          value: item.module_id,
          text: item.value_code
        };
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues() {
      this.user = this.defaultValue;
      this.module = this.defaultValue;
    },
    clearinputdata() {
      this.module = {
        value: null,
        text: null
      };
      this.fileName = null;
      this.uploadedFrom = null;
      this.uploadedTo = null;
      this.user = {
        value: null,
        text: null
      };
      this.uploadedData= [];
      this.totalRows = null;
      // this.perPage = commonHelper.perPageRecord;
    },
    getUploadedData() {
      if (!this.module.value) {
        alert('Please fill in mandatory fields');
      } else {
        const payload = {
          module_id: this.module.value,
          user_id: this.user.value,
          file_name: this.fileName ? this.fileName : null,
          from_date: this.uploadedFrom,
          to_date: this.uploadedTo,
          total_page: this.perPage,
          page: this.currentPage - 1
        };
        this.loader = true;
        this.$store
          .dispatch('provisionsAdmin/getUploadedData', payload)
          .then(resp => {
            this.loader = false;
            if (resp.status === 200) {
            
              this.uploadedData = resp.data.data.page.map(item => {
                return {
                  ...item,
                  creation_date: this.formatDate(item.creation_date),
                  //created_by: this.getUserName(item.created_by),
                  excel_name: this.extractFileName(item.excel_name)
                };
              });
              this.totalRows = resp.data.data.total_elements;
              //this.excelImportId = this.uploadedData[0].excel_import_hdr_id;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');      // Ensures 2-digit day
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = date.getFullYear();
  return `(${day}/${month}/${year})`;
},

    getUserName(userId) {
      const user = this.users.find(u => u.value === userId);
      return user ? user.text : userId;
    },

    extractFileName(fileName) {
      if (!fileName) return '';
      return fileName.split(/[\s(]/)[0].replace(/\.[^/.]+$/, '');
    },
    showExcelDetails(flag, rowData, index) {
      this.showExcelDetailsModal = flag;
      this.excelRowDtl = rowData;
      this.sheetIndex = index;
    },
    closeExcelDetail(columns) {
      if (columns || columns === 0) {
        this.uploadExcelData[this.sheetIndex].mapped_column = columns;
      }
      this.showExcelDetails(false);
    },
    uploadProvisionData(excelImportHdrId) {
      const payload = {
        excel_import_id: excelImportHdrId
      };
      this.$store
        .dispatch('provisionsAdmin/uploadProvisionData', payload)
        .then(response => {
          this.showAlert = true;
          if (response.status === 200) {
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })

        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    }
  }
};
